export const wrapOnFieldChanged = (originalOnchange, newOnChange) => {
    return e => {
        originalOnchange(e)
        newOnChange && newOnChange(e)
    }
}